export var ProjectsSortingValues;
(function (ProjectsSortingValues) {
    ProjectsSortingValues[ProjectsSortingValues["RECENT_PROJECTS"] = 0] = "RECENT_PROJECTS";
})(ProjectsSortingValues || (ProjectsSortingValues = {}));
